var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSorting = function SvgSorting(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.455 12.464a.687.687 0 010 .971l-2.891 2.892a.687.687 0 01-.972 0l-2.891-2.892a.687.687 0 11.971-.97l2.406 2.405 2.406-2.406a.687.687 0 01.971 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.078 4.167c.38 0 .687.307.687.687V15.84a.687.687 0 11-1.374 0V4.854c0-.38.308-.687.687-.687zM10.545 8.23a.687.687 0 010-.97l2.892-2.892a.687.687 0 01.97 0L17.3 7.26a.687.687 0 11-.971.97l-2.406-2.405-2.406 2.406a.687.687 0 01-.971 0z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.922 16.528a.687.687 0 01-.687-.686V4.854a.687.687 0 111.374 0v10.988c0 .379-.308.686-.687.686z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgSorting);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/Sorting.185f7f5e05276a8e74a4a88b3279d4f2.svg";